export class nodiEntrantiSinonimiaservice {
    nodiEntrantiSinonimia(event) {
        console.log("funzione nodi entranti sinonimia");

        let nodoDBClick = event.target;
        let nodoDBincomers = event.target.incomers();
        var nodoDBincomersPredecessors = nodoDBincomers.sources().predecessors().sources();
        var nodoDBincomersSuccessors = nodoDBincomers.sources().successors().targets();

        var edgePrecedessorsSources = nodoDBincomers.sources().predecessors();
        var edgeSuccessorsTargets = nodoDBincomers.sources().successors();
        var edgePredecessors = nodoDBincomers.predecessors();
        var edgeSuccessors = nodoDBincomers.successors();

        nodoDBincomers.style("display", "element");


        // istruzioni per colorare nodi e archi di secondo livello in grigio
        // incomers classe iponimia
        nodoDBincomersPredecessors.removeClass("iponimia");
        nodoDBincomersSuccessors.removeClass("iponimia");
        nodoDBincomersPredecessors.removeClass("iponimiaDBClick");
        nodoDBincomersSuccessors.removeClass("iponimiaDBClick");

        // incomers classe meronimia
        nodoDBincomersPredecessors.removeClass("meronimia");
        nodoDBincomersSuccessors.removeClass("meronimia");
        nodoDBincomersPredecessors.removeClass("meronimiaDBClick");
        nodoDBincomersSuccessors.removeClass("meronimiaDBClick");

        // incomers classe sinonimia
        nodoDBincomersPredecessors.removeClass("sinonimia");
        nodoDBincomersSuccessors.removeClass("sinonimia");
        nodoDBincomersPredecessors.removeClass("sinonimiaDBClick");
        nodoDBincomersSuccessors.removeClass("sinonimiaDBClick");

        // edges
        edgePrecedessorsSources.removeClass("edges");
        edgeSuccessorsTargets.removeClass("edges");

        // se nodi sono tra 20 e 200
        if (nodoDBincomers.sources().toArray().length > 20 && nodoDBincomers.sources().toArray().length < 200) {
            //  layout sinonimi
            var sinonimiIncomers = event.target.incomers('edge[relationType = "synonym"]').sources().layout({
                name: "grid", fit: true, boundingBox: {
                    x1: nodoDBClick.position('x') - 500, y1: nodoDBClick.position("y") + 100,
                    h: 50, w: 50
                }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 14, animate: false
            });

            sinonimiIncomers.run();

            if (nodoDBincomers.sources().predecessors().sources().toArray().length > 20 || nodoDBincomers.sources().successors().targets().toArray().length > 20) {
                // nodes
                nodoDBincomersPredecessors.addClass("2livello");
                nodoDBincomersSuccessors.addClass("2livello");

                // edges
                edgePredecessors.addClass("2livello");
                edgeSuccessors.addClass("2livello");
                nodoDBClick.removeClass("2livello");
                nodoDBincomers.sources().removeClass("2livello");
                nodoDBincomers.removeClass("2livello");
            }

        } else if (nodoDBincomers.sources().toArray().length > 200) {
            // layout sinonimi
            var sinonimiIncomers = event.target.incomers('edge[relationType = "synonym"]').sources().layout({
                name: "grid", fit: true, boundingBox: {
                    x1: nodoDBClick.position('x') - 1000, y1: nodoDBClick.position("y") + 200,
                    h: 200, w: 200
                }, avoidOverlap: true, avoidOverlapPadding: 20, cols: 28, animate: false
            });

            sinonimiIncomers.run();

            if (nodoDBincomers.sources().incomers().sources().toArray().length > 20 || nodoDBincomers.sources().outgoers().targets().toArray().length > 20) {
                // nodes
                nodoDBincomers.sources().predecessors().sources().addClass("2livello");
                nodoDBincomers.sources().successors().targets().addClass("2livello");
                // edges
                nodoDBincomers.predecessors().addClass("2livello");
                nodoDBincomers.successors().addClass("2livello");

                nodoDBClick.removeClass("2livello");
                nodoDBincomers.sources().removeClass("2livello");
                nodoDBincomers.removeClass("2livello");
            }
            // posizionamento nodi nel caso di quantità inferiore a 20
        } else {

            nodoDBClick.removeClass("2livello");
            nodoDBincomers.sources().removeClass("2livello");
            nodoDBincomers.removeClass("2livello");

            // posizioni nodo cliccato, nodi entranti, nodi uscenti DA RIVEDERE
            nodoDBincomers.positions(function (nodi, i) {
                var xc = nodoDBClick.position('x');
                var yc = nodoDBClick.position('y');
                var xRet = i % 2 == 1 ? (xc + 50 * i) : (xc + 50 * (i - i * 2 - 1));
                var yRet = yc + 75;
                return {
                  x: xRet,
                  y: yRet
                };
            });
        }

        return true
    }
}